import { ModelMixin } from '@app/models/core/base-generic.model';

export class Customer extends ModelMixin<Customer>() {
    protected static _resource = 'billingCustomer';

    protected static _version = 'v2';
}
